import { atom } from "recoil";

import { persistAtom } from "./persist";

export type TSurveyPromptState = {
  snoozedUntil: number | null;
  dismissedForever: boolean;
};

export const SurveyPromptState = atom<TSurveyPromptState>({
  key: "SurveyPrompt_v1",
  default: { snoozedUntil: null, dismissedForever: false },
  effects_UNSTABLE: [persistAtom],
});
